import React from 'react';

import PlatformIcon from '@/components/AppReleases/PlatformIcon';
import {AppPlatform} from '@/types/FirebaseAppDistribution';

interface PlatformSelectorProps {
  currentPlatform: AppPlatform;
  onPlatformChange: (platform: AppPlatform) => void;
  disabled?: boolean;
}

const PlatformSelector: React.FC<PlatformSelectorProps> = ({
  currentPlatform,
  onPlatformChange,
  disabled = false,
}) => {
  const platforms = [
    {value: AppPlatform.IOS, label: 'iOS', color: 'text-gray-600'},
    {value: AppPlatform.ANDROID, label: 'Android', color: 'text-green-600'},
  ];

  return (
    <div className="flex mt-3 md:mt-0 space-x-1 bg-gray-100 dark:bg-gray-700 rounded-lg p-1">
      {platforms.map((platform) => {
        const isActive = currentPlatform === platform.value;

        return (
          <button
            key={platform.value}
            onClick={() => onPlatformChange(platform.value)}
            disabled={disabled}
            className={`
              flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium 
              transition-colors duration-200 focus:outline-none focus:ring-2 
              focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 
              disabled:cursor-not-allowed
              ${
                isActive
                  ? 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow-sm'
                  : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-gray-50 dark:hover:bg-gray-600'
              }
            `}
          >
            <PlatformIcon
              platform={platform.value}
              size="sm"
              className={
                isActive ? platform.color : 'text-gray-400 dark:text-gray-500'
              }
            />
            {platform.label}
          </button>
        );
      })}
    </div>
  );
};

export default PlatformSelector;
